import React from 'react';
import { makeStyles, createStyles, Theme, styled } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';
import sectionImg from 'assets/cloud-desktop/cloud-desktop-premium-block1.png';

const HeroBlock = styled(Box)({
  background: '#fff',
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      maxWidth: theme.breakpoints.values['lg'],
      margin: '0 auto',
      backgroundImage: `url(${sectionImg})`,
      backgroundSize: '58%',
      backgroundPosition: 'right',
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#fff',
      color: '#423f3f',
      padding: theme.spacing(8, 3),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(4, 3),
        backgroundImage: 'none',
      },
    },
    paper: {
      height: 140,
      width: 100,
    },
    control: {
      padding: theme.spacing(2),
    },
    label: {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: 'normal',
      color: '#737373',
    },
    title: {
      fontSize: 34,
      fontWeight: 700,
    },
    text: {
      fontSize: 18,
      marginBottom: '235px',
      display: 'inline-block',
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
      },
    },
  })
);

const CloudDesktopPremium1: React.FC = () => {
  const classes = useStyles();

  return (
    <HeroBlock component="div" id="VelocitySolutions">
      <Grid container className={classes.root}>
        <Grid item xs={12} md={6}>
          <Typography variant="h5" component="span" className={classes.label} gutterBottom>
            Velocity
          </Typography>
          <br />

          <Typography variant="h4" component="h2" className={classes.title} gutterBottom>
            Cloud Desktop Premium
          </Typography>
          <br />

          <Typography variant="body1" component="span" className={classes.text}>
            {`Velocity Cloud Desktop Premium for Microsoft WVD is an automation platform that helps IT Pros deploy, manage, and autoscale WVD resources.`}
          </Typography>
          <br />
          <br />
        </Grid>
      </Grid>
    </HeroBlock>
  );
};

export default CloudDesktopPremium1;
